import './breadcrumbs/gb-breadcrumbs.tag.html';
import './carousel/gb-carousel.tag.html';
import './category-menu/gb-category-menu.tag.html';
import './collections/gb-collections.tag.html';
import './details/gb-details.tag.html';
import './did-you-mean/gb-did-you-mean.tag.html';
import './filter/gb-filter.tag.html';
import './navigation/gb-navigation.tag.html';
import './page-size/gb-page-size.tag.html';
import './paging/gb-pager.tag.html';
import './paging/gb-pages.tag.html';
import './paging/gb-paging.tag.html';
import './paging/gb-terminal-pager.tag.html';
import './query/gb-query.tag.html';
import './raw/gb-raw.tag.html';
import './record-count/gb-record-count.tag.html';
import './related-queries/gb-related-queries.tag.html';
import './reset/gb-reset.tag.html';
import './results/gb-results.tag.html';
import './sayt/gb-sayt.tag.html';
import './select/gb-select.tag.html';
import './snippet/gb-snippet.tag.html';
import './sort/gb-sort.tag.html';
import './submit/gb-submit.tag.html';
import './template/gb-template.tag.html';



/** WEBPACK FOOTER **
 ** ./~/source-map-loader!./src/tags/index.ts
 **/